import { NumberParam, StringParam, ArrayParam } from 'use-query-params';

export const dashboardQueryTypes = {
  offset: NumberParam,
  limit: NumberParam,
  sortBy: StringParam,
  order: StringParam,
  search: StringParam,
  region: StringParam,
  columns: ArrayParam,
};

export const confirmEmailQueryTypes = {
  confirmationCode: StringParam,
  email: StringParam,
};

export const resetPasswordQueryTypes = {
  resetPasswordCode: StringParam,
  email: StringParam,
};
